import { System } from '../core/System';
import type { Entity } from '../core/Entity';
import { Transform } from '../components/Transform';
import { Velocity } from '../components/Velocity';

/**
 * Applies velocity to transform position.
 */
export class MovementSystem extends System {
  requiredComponents = [Transform, Velocity];

  update(entities: Entity[], delta: number): void {
    for (const entity of entities) {
      const transform = entity.get(Transform);
      const velocity = entity.get(Velocity);

      transform.x += velocity.vx * delta;
      transform.y += velocity.vy * delta;
    }
  }
}
